import superMeta from '../_CAT_ROOT_MODULE/metaCatRootModuleNode.mjs'

export default {
    ...superMeta,
    moduleIdProp: 'cmId',
    moduleType: 'CM',
    name: '用例模块',
    type: 'CAT_ROOT_CM',
}
